import Segment from '@/Segment';

const STORAGE_KEY = 'riseup.intercomHasOpenConversation';

function _readPersistedHasOpenConversation() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch (_e) {
    return false;
  }
}

function _persistHasOpenConversation(value) {
  try {
    if (value) {
      localStorage.setItem(STORAGE_KEY, 'true');
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch (_e) {
    // localStorage may be unavailable (private mode, quota) — fail silently
  }
}

const state = {
  unreadMessages: null,
  showOnInit: false,
  isOpen: false,
  // Session-only dismissal (not persisted) so the X can hide the bar even while there are
  // unread messages. Any fresh positive signal (escalation / open / new unread) clears it.
  barDismissed: false,
  hasOpenConversation: _readPersistedHasOpenConversation(),
};

const getters = {
  shouldShowBar(state, _getters, _rootState, rootGetters) {
    if (!rootGetters['featureFlags/cxAgentUiChanges'] || state.isOpen || state.barDismissed) {
      return false;
    }
    return state.hasOpenConversation || state.unreadMessages > 0;
  },
};

const actions = {
};

const mutations = {
  setUnreadMessages(state, unreadMessages) {
    state.unreadMessages = unreadMessages;
  },
  setShowOnInit(state, showOnInit) {
    state.showOnInit = showOnInit;
  },
  setIsOpen(state, isOpen) {
    state.isOpen = isOpen;
  },
  setBarDismissed(state, barDismissed) {
    state.barDismissed = barDismissed;
  },
  setHasOpenConversation(state, hasOpenConversation) {
    const wasOpen = state.hasOpenConversation;
    state.hasOpenConversation = hasOpenConversation;
    _persistHasOpenConversation(hasOpenConversation);
    if (hasOpenConversation) {
      // A fresh positive signal re-surfaces the bar even after a prior dismissal.
      state.barDismissed = false;
    }
    if (hasOpenConversation && !wasOpen) {
      Segment.trackUserGot('IntercomBottomBar_OpenConversationDetected');
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
